/**
 * «Клиенты и откуда лиды».
 * Портфель купивших клиентов по фазам (внедрение / гиперкэр / активен / под угрозой)
 * + откуда приходит входящий поток (донат источников).
 */

import { Link } from '@tanstack/react-router'
import { Building2, Radio } from 'lucide-react'
import { BarList, Donut } from './primitives'
import type { BarRow, DonutSlice } from './primitives'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { ClientPhaseBucket, DashboardClients } from '@/types'

const PHASE_ACCENT: Record<ClientPhaseBucket['phase'], BarRow['accent']> = {
  delivery: 'primary',
  hypercare: 'amber',
  active: 'green',
  at_risk: 'red',
}

const SOURCE_LABEL: Record<string, string> = {
  web_form: 'Сайт',
  telegram: 'Telegram',
  max: 'MAX',
  avito: 'Авито',
  manual: 'Вручную',
}

// палитра доната — фиксированные hex, чтобы conic-gradient был стабилен
const SOURCE_COLOR: Record<string, string> = {
  telegram: '#0ea5e9',
  web_form: '#6366f1',
  avito: '#22c55e',
  manual: '#94a3b8',
  max: '#f59e0b',
}

export function ClientsBlock({ clients }: { clients: DashboardClients }) {
  const phaseRows: BarRow[] = clients.by_phase.map((p) => ({
    label: p.label,
    value: p.count,
    accent: PHASE_ACCENT[p.phase],
  }))

  const sourceSlices: DonutSlice[] = clients.lead_sources.map((s) => ({
    label: SOURCE_LABEL[s.source_channel] ?? s.source_channel,
    value: s.count,
    color: SOURCE_COLOR[s.source_channel] ?? '#94a3b8',
  }))
  const totalLeads = clients.lead_sources.reduce((a, b) => a + b.count, 0)

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <Card>
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <CardTitle className="flex items-center gap-2 text-base">
              <Building2 className="h-4 w-4 text-muted-foreground" />
              Клиенты по фазе
            </CardTitle>
            <Link to="/clients" className="text-xs text-primary hover:underline">
              Всего: {clients.total_clients} →
            </Link>
          </div>
        </CardHeader>
        <CardContent>
          {phaseRows.length === 0 ? (
            <p className="py-4 text-center text-sm text-muted-foreground">Клиентов пока нет</p>
          ) : (
            <BarList rows={phaseRows} />
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-base">
            <Radio className="h-4 w-4 text-muted-foreground" />
            Лиды по источникам
          </CardTitle>
        </CardHeader>
        <CardContent>
          {sourceSlices.length === 0 ? (
            <p className="py-4 text-center text-sm text-muted-foreground">Источников пока нет</p>
          ) : (
            <Donut slices={sourceSlices} centerTop={totalLeads} centerBottom="лидов" />
          )}
        </CardContent>
      </Card>
    </div>
  )
}
